import { postRequest } from "../apiRequest";
import { apiRoutes } from "../Constants/ApiRoutes";

/** Normalize to array; accept single object or alternate keys. */
function normalizeSources(data) {
    const raw = data.sources ?? data.source ?? data.references ?? data.source_list ?? [];
    if (Array.isArray(raw)) return raw;
    if (raw && typeof raw === "object" && !Array.isArray(raw)) return [raw];
    return [];
}

/** Build source entry from a search result (fullPath or categorySlug/slug). */
function searchResultToSource(item, index) {
    const url = item.fullPath
        ? (item.fullPath.startsWith("/") ? item.fullPath : `/${item.fullPath}`)
        : item.categorySlug
            ? `/${item.categorySlug}/${item.slug || ""}`
            : item.slug
                ? `/${item.slug}`
                : null;
    return {
        id: item.articleId ?? item.id ?? index,
        kb_id: item.articleId ?? item.kb_id,
        title: item.title ?? item.name,
        url: url || item.url,
    };
}

/**
 * AI/LLM search: POST article/ai-search. Routes via postRequest:
 *   - Public KB → public/v1/article/ai-search (no auth needed)
 *   - Internal KB → Bifrost (with session auth)
 * @param {{ query: string }} params
 * @returns {Promise<{ content: string, sources: any[] }>}
 */
export async function getAiSearchResponse({ query = "" }) {
    const searchTerm = (query || "").trim();
    const res = await postRequest(apiRoutes.kbArticleAiSearch, { searchTerm });
    let data = res?.data?.data ?? res?.data ?? res;
    if (Array.isArray(data)) data = data[0] ?? {};
    const searchResults = Array.isArray(data.search_results)
        ? data.search_results
        : [];
    let sources = normalizeSources(data);
    if (sources.length === 0 && searchResults.length > 0) {
        sources = searchResults.map((item, i) => searchResultToSource(item, i));
    }
    return {
        content: data.content ?? "",
        sources,
    };
}
